module.exports = __webpack_public_path__ + "static/img/bottom_left.b4035e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom_left.png
// module id = WN8x
// module chunks = 1